var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: _vm.titulo[_vm.editar] } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|max:10|SinEspacioTrama",
                                    expression:
                                      "'required|max:10|SinEspacioTrama'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.trama.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.trama.id
                                  ),
                                  "data-vv-name": _vm.formFields.trama.id,
                                  counter: 10,
                                  disabled: _vm.esEditar,
                                  "data-testid": _vm.testId + "--trama"
                                },
                                model: {
                                  value: _vm.formFields.trama.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.trama, "value", $$v)
                                  },
                                  expression: "formFields.trama.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|numeric|max:10",
                                    expression: "'required|numeric|max:10'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.posicion.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.posicion.id
                                  ),
                                  "data-vv-name": _vm.formFields.posicion.id,
                                  counter: 10,
                                  disabled: _vm.esEditar,
                                  "data-testid": _vm.testId + "--posicion"
                                },
                                model: {
                                  value: _vm.formFields.posicion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.posicion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.posicion.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      "max:80|required|NombreUnicoFront|NombreUnicoBack|alpha_dash",
                                    expression:
                                      "\n                  `max:80|required|NombreUnicoFront|NombreUnicoBack|alpha_dash`\n                "
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.nombre.label,
                                  "data-vv-name": _vm.formFields.nombre.id,
                                  id: _vm.formFields.nombre.id,
                                  counter: "80",
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.nombre.id
                                  ),
                                  "data-testid": _vm.testId + "--nombre"
                                },
                                model: {
                                  value: _vm.formFields.nombre.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.nombre,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.nombre.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm6: "", md6: "" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.tiposMedida,
                                  label: _vm.formFields.medida.label,
                                  "data-vv-name": _vm.formFields.medida.id,
                                  "no-data-text": "Sin resultados",
                                  "item-text": "nombre",
                                  "item-value": "id",
                                  "data-testid": _vm.testId + "--tipoMedida"
                                },
                                model: {
                                  value: _vm.formFields.medida.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.medida,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.medida.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "max:200|required",
                                    expression: "'max:200|required'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.descripcion.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.descripcion.id
                                  ),
                                  "data-vv-name": _vm.formFields.descripcion.id,
                                  counter: 200,
                                  "data-testid": _vm.testId + "--descripcion"
                                },
                                model: {
                                  value: _vm.formFields.descripcion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.descripcion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.descripcion.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "max:2000|SinEspacioLink",
                                    expression: "'max:2000|SinEspacioLink'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.link.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.link.id
                                  ),
                                  "data-vv-name": _vm.formFields.link.id,
                                  counter: 2000,
                                  "data-testid": _vm.testId + "--link"
                                },
                                model: {
                                  value: _vm.formFields.link.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.link, "value", $$v)
                                  },
                                  expression: "formFields.link.value"
                                }
                              })
                            ],
                            1
                          ),
                          _vm.iconoUrl !== ""
                            ? _c("v-flex", { attrs: { sm1: "", md1: "" } }, [
                                _vm.iconoUrl !== ""
                                  ? _c("img", {
                                      attrs: {
                                        src: _vm.iconoUrl,
                                        height: "50",
                                        alt: "icono"
                                      }
                                    })
                                  : _vm._e()
                              ])
                            : _vm._e(),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                sm5: _vm.iconoUrl !== "",
                                sm6: _vm.iconoUrl == "",
                                md5: _vm.iconoUrl !== "",
                                md6: _vm.iconoUrl == ""
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Ícono",
                                  heigh: "",
                                  "prepend-icon": "attach_file",
                                  readonly: "readonly"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.$refs.image.click()
                                  }
                                },
                                model: {
                                  value: _vm.icono.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.icono, "name", $$v)
                                  },
                                  expression: "icono.name"
                                }
                              }),
                              _c("input", {
                                ref: "image",
                                staticStyle: { display: "none" },
                                attrs: {
                                  type: "file",
                                  accept: "image/png, image/jpeg"
                                },
                                on: { change: _vm.onFilePicked }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { md12: "" } },
                            [
                              _c("div", { attrs: { align: "left" } }, [
                                _c(
                                  "h2",
                                  [
                                    _vm._v(
                                      "\n                  Condición Visible\n                  "
                                    ),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          flat: "",
                                          icon: "",
                                          small: ""
                                        },
                                        on: {
                                          click: _vm.handleValidarRespuestaClick
                                        }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "#228B22" } },
                                          [_vm._v("play_arrow")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]),
                              _c("v-divider")
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { md12: "" } },
                            [
                              _c("CodeView", {
                                attrs: {
                                  "data-vv-name": _vm.formFields.valorScript.id
                                },
                                on: { blur: _vm.handleMapeoRespuestaBlur },
                                model: {
                                  value: _vm.formFields.valorScript.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.valorScript,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.valorScript.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("ValidarRespuestaModal", {
            attrs: {
              show: _vm.muestraModalValidar,
              script: _vm.formFields.valorScript.value
            },
            on: {
              cerrar: function($event) {
                return _vm.handleCierreModal($event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }